import { css } from '@eti/styles';
import { breakpoints } from '@etg/wings';
export const viSmallCardHeaderGrid = css`
  display: grid;
  grid-template-columns: auto 1fr;
  grid-template-rows: repeat(2, auto);

  .title {
    grid-area: 2 / 1 / 3 / 3;

    @media (max-width: ${breakpoints._768}) {
      grid-area: 2 / 2 / 3 / 3;
    }
  }

  .children {
    display: flex;
    gap: 8px;
    grid-area: 1 / 1 / 2 / 3;
    margin-bottom: 8px;
  }

  .pictogram {
    height: 2rem;
    margin-inline-end: 8px;
    margin-top: 2px;
    width: 2rem;
  }
`;
//# sourceMappingURL=styles.js.map